import { Box, Button, Fade, Flex, Text, VStack, useColorModeValue } from '@chakra-ui/react';
import { FileUploader } from 'react-drag-drop-files';
import { ExcelIcon, PDFIcon, UploadIcon2 } from '@assets/icons';
import { CloseIcon } from '@chakra-ui/icons';
import { formatFileSize } from '@helpers/utils';
import { ConditionalComponent } from '@components/functionComponent';
import React from 'react';

export default function FileUploadField({
    selectedFile = null,
    fileTypes = ['xls', 'xlsx', 'csv', 'pdf'],
    maxFileSize = 5,
    errorMessage,
    onFileChange,
    onFileError,
    onSizeError,
    onFileReset,
    title = 'Drag and drop file disini, atau',
    actionText = 'Pilih File',
    isWhiteBg = false,
}) {
    const accessFile = selectedFile ? selectedFile[0] : null;
    const fileTypeMapping = fileTypes.map((ext) => ext.toUpperCase()).join(', ');
    const Icon = accessFile?.type !== 'application/pdf' ? <ExcelIcon size={38} /> : <PDFIcon size={28} />;

    const handleTypeError = () => {
        const message = `Format file yang diperbolehkan hanya ${fileTypes
            .map((file) => `.${file.toUpperCase()}`)
            .join(', ')
            .replace(/, ([^,]*)$/, ' atau $1')}.`;

        onFileError?.(message);
    };

    const handleSizeError = () => {
        const message = `Ukuran file yang dipilih melebihi batas maksimum ${maxFileSize} MB.`;
        onSizeError?.(message);
    };

    const bg = isWhiteBg
        ? {
              bg: 'semantic.100',
              _hover: { bg: 'semantic.200' },
          }
        : {
              bg: 'semantic.200',
              _hover: { bg: 'semantic.100' },
          };

    return (
        <Box data-testid="upload-full-zone__container">
            <Fade in={accessFile}>
                {accessFile && (
                    <Boxcontainer bg={bg} cursor={'default'}>
                        <Flex flexDir={'column'} alignItems={'center'}>
                            {Icon}

                            <Flex alignItems={'center'} mt={'.8rem'}>
                                <Text fontSize={'14px'} fontWeight={'700'}>
                                    {accessFile.name}
                                </Text>
                                <Button variant={'unstyled'} onClick={onFileReset}>
                                    <CloseIcon fontSize={'.7rem'} color={'sagitarius.600'} />
                                </Button>
                            </Flex>
                            <Text fontSize={'14px'} color={'semantic.500'}>
                                {formatFileSize(accessFile.size)}
                            </Text>
                        </Flex>
                    </Boxcontainer>
                )}
            </Fade>

            <Fade in={!accessFile}>
                {!accessFile && (
                    <FileUploader
                        handleChange={onFileChange}
                        onTypeError={handleTypeError}
                        onSizeError={handleSizeError}
                        types={fileTypes}
                        maxSize={maxFileSize}
                    >
                        <Boxcontainer bg={bg} data-testid="file-input__global">
                            <VStack spacing={2}>
                                <UploadIcon2 size={28} color="#C2C2C2" />

                                <Text fontSize="14px" color="neutral.500" mb="16px" pt="16px">
                                    {title}{' '}
                                    <Box display="inline" color="paragon.500" fontSize="14px">
                                        {actionText}
                                    </Box>
                                </Text>

                                <Text fontSize="12px" color="neutral.400">
                                    Format file didukung: {fileTypeMapping} (Maks. {maxFileSize} Mb)
                                </Text>
                            </VStack>
                        </Boxcontainer>
                    </FileUploader>
                )}
            </Fade>

            <ConditionalComponent statement={errorMessage}>
                <Fade in={!accessFile}>
                    <Text fontSize="12px" color="danger.600" mt="12px">
                        {errorMessage}
                    </Text>
                </Fade>
            </ConditionalComponent>
        </Box>
    );
}

const Boxcontainer = ({ children, bg, ...rest }) => {
    return (
        <Box
            border="3px dashed"
            borderColor={useColorModeValue('gray.300', 'gray.600')}
            borderRadius="8px"
            p="40px"
            cursor="pointer"
            transition="background 0.2s"
            {...bg}
            {...rest}
        >
            {children}
        </Box>
    );
};
